import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
}
const OFFER_URL = 'https://trackrt.activapleno.com/click';
export function CTAButton({
  children,
  className = ''
}: CTAButtonProps) {
  return <a href={OFFER_URL} className={`inline-flex items-center justify-center gap-2 font-bold text-white bg-[#F5A623] hover:bg-[#D4891A] text-lg md:text-xl py-4 px-10 rounded-xl transition-all duration-200 shadow-[0_4px_14px_0_rgba(245,166,35,0.4)] hover:shadow-[0_6px_20px_rgba(245,166,35,0.25)] hover:-translate-y-0.5 active:translate-y-0 active:shadow-none no-underline ${className}`} data-id="element-81">
      {children}
      <ArrowRightIcon className="w-5 h-5" data-id="element-82" />
    </a>;
}